import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "modalConfirmAgain",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = { class: "modal-title fw-bold text-center w-100" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1)
const _hoisted_7 = { class: "bodal-body content p-0" }
const _hoisted_8 = { class: "text-center py-4 border-bottom" }
const _hoisted_9 = {
  key: 0,
  class: "border-bottom"
}
const _hoisted_10 = { class: "py-4 text-center" }
const _hoisted_11 = { class: "bg-light py-3 ps-3 pe-2 mb-4" }
const _hoisted_12 = { class: "list-id" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode()
const _hoisted_14 = { class: "me-2" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode()
const _hoisted_16 = { class: "d-flex justify-content-center my-4" }

import { PropType, ref, watchEffect } from 'vue'
import { useRouter } from 'vue-router'

import { translate } from '@/languages/i18n'
import Button from '@/components/button/index.vue'
import UserAliasIcon from '@/components/user-alias-icon/index.vue'
import { COMMUNITY_ALUMNUS_STORE, COMMUNITY_USERS_STORE, CONVERSATIONS_STORE } from '@/store/constants'
import { useStore } from 'vuex'


export default /*#__PURE__*/_defineComponent({
  props: {
  data: Array,
  listUserFailed: Array,
  typeModal: String as PropType<'user' | 'alumnai'>,
  hanldeErrorServer: Boolean,
},
  setup(__props) {

const props = __props

const listUser = ref<any[]>([])
const router = useRouter()


const store = useStore()

const transitList = () => {
  const query = { management_no: 'desc' }
  store.dispatch(CONVERSATIONS_STORE.ACTIONS.SET_DATA_SEARCH_DETAIL, { typeData: 'clearData', data: [] })
  let path = `/community/communities/${router.currentRoute.value.params?.id}/alumnus`
  store.dispatch(COMMUNITY_ALUMNUS_STORE.ACTIONS.SET_DATA_SEARCH_ALUMNUS, [])
  if (props.typeModal === 'user') {
    store.dispatch(COMMUNITY_USERS_STORE.ACTIONS.SET_DATA_SEARCH, [])
    path = `/community/communities/${router.currentRoute.value.params?.id}/community-users`
  }

  router.push({ path, query })
}
watchEffect(() => {
  const { data, listUserFailed } = props
  listUser.value = data?.filter((item: any) => listUserFailed?.includes(item?.management_no))
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h5", _hoisted_5, _toDisplayString(_unref(translate)('OE53titleManagementFlag')), 1),
          _hoisted_6
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(translate)(__props.hanldeErrorServer ? 'updateCompleteFail' : 'updateComplete')), 1),
          (__props.listUserFailed?.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(translate)('OE10updateFailed')), 1),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("ul", _hoisted_12, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(listUser.value, (item, index) => {
                      return (_openBlock(), _createElementBlock("li", {
                        class: "mb-2 d-flex align-items-center",
                        key: index
                      }, [
                        _createVNode(UserAliasIcon, {
                          userType: item?.user_type
                        }, null, 8, ["userType"]),
                        _hoisted_13,
                        _createElementVNode("span", _hoisted_14, _toDisplayString(item?.management_no), 1),
                        _hoisted_15,
                        _createElementVNode("span", null, _toDisplayString(item.family_name + ' ' + item.given_name), 1)
                      ]))
                    }), 128))
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_16, [
            _createVNode(Button, {
              title: _unref(translate)(__props.typeModal === 'user' ? 'OE53backUser' : 'OE53backAlumni'),
              type: 'secondary',
              "data-bs-dismiss": "modal",
              onClick: transitList
            }, null, 8, ["title"])
          ])
        ])
      ])
    ])
  ]))
}
}

})